import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import isElectron from 'is-electron';
import appConfig from 'app-config';
import HomeClient from 'flow/api-clients/home-client';
import { getQueryParam } from 'flow/utils/browser-utils';
import { jsx as _jsx } from "react/jsx-runtime";
var AuthWithToken = /*#__PURE__*/function (_React$PureComponent) {
  function AuthWithToken(props) {
    var _this;
    _classCallCheck(this, AuthWithToken);
    _this = _callSuper(this, AuthWithToken, [props]);
    _this.state = {
      redirect: false
    };
    return _this;
  }
  _inherits(AuthWithToken, _React$PureComponent);
  return _createClass(AuthWithToken, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var authToken = this.props.match.params.authToken;
      var location = this.props.location;
      if (authToken) {
        if (appConfig.production && !isElectron()) {
          var hostParam = getQueryParam(location.search, 'host');
          if (hostParam) {
            HomeClient.apiHost = 'https://' + hostParam;
          }
        }
        HomeClient.authToken = authToken;
        this.setState({
          redirect: true
        }); // eslint-disable-line react/no-did-mount-set-state
      }
    }
  }, {
    key: "render",
    value: function render() {
      var params = this.props.match.params;
      var redirectPath = params[0] ? "/".concat(params[0]) : '/';
      if (this.state.redirect) {
        return /*#__PURE__*/_jsx(Redirect, {
          to: redirectPath
        });
      }
      return null;
    }
  }]);
}(React.PureComponent);
_defineProperty(AuthWithToken, "propTypes", {
  match: PropTypes.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  location: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
});
export default AuthWithToken;